const lang = {
  page_title: 'シミュレーション選択',
  button: {
    create: 'シミュレーションの追加',
    confirmed: '確定',
  },
  table: {
    name: 'シミュレーション名',
    certification_period: '認証期間',
    expected_co2_absorption_quantity: '見込みCO2吸収量',
    revenue: '収益',
    delete: '削除',
  },
  create_modal: {
    title: 'シミュレーションの追加',
    create_button: 'シミュレーションの追加',
    simulation_name: 'シミュレーション名',
    certification_period: '認証期間',
    cost_and_subsidy: '創出コスト・補助金',
    fixed_volume_calculation: '幹材積固定量計算パラメタ',
    forest_parameters: '林地コスト・単価等',
    credit_price: 'クレジット単価',
    protection_year: '保護年度',
    area_type: '面積の値について',
    area_evidence: '想定値の場合の根拠資料',
    position_type: '地位の値について',
    position_evidence: '想定値の場合の根拠資料',
    bulk_application_type: '主伐再造林地の標準伐期齢までの一括申請の有無',
    select_button: '選択する',
    actual_value: '実測値',
    estimated_value: '想定値',
    has_application: 'あり',
    no_application: 'なし',
  },
  trunk_volume_parameter_modal: {
    title: '幹材積固定量計算パラメタの選択',
    no_data_massage: '幹材積固定量計算パラメタが作成されていません。',
    select: '選択する',
    set_default_timber_shipment_params: '木材出荷量の計算パラメタをデフォルト値に変更',
    harvested_trunk_shipping_ratio: '伐採した幹材積のうち出荷する割合',
    sawmill_ratio: '出荷木材のうち製材用材の割合',
    plywood_ratio: '出荷木材のうち合板用材の割合',
    wood_board_ratio: '出荷木材のうち木質ボードの割合',
    set_default_trunk_volume_params: '幹材積固定量の計算パラメタをデフォルト値に変更',
    warning_statement: '※デフォルト値以外の値を用いる場合、根拠となる資料の提出が必要になります。',
    input_value: '値を入力',
    add_items: '+ 項目を追加する',
  },
  create_trunk_volume_parameter_modal: {
    title: '幹材積固定量計算パラメタの追加',
    name: '幹材積固定量計算パラメタ',
    timber_shipment_params: '木材の出荷量の計算パラメタ',
    trunk_volume_fixed_params: '幹材積固定量の計算パラメタ',
  },
  trunk_volume_parameter_delete_modal: {
    title: '幹材積固定量計算パラメタの削除',
  },
  edit_trunk_volume_parameter_modal: {
    title: '幹材積固定量計算パラメタの編集',
  },
}

export default lang
